import { render, staticRenderFns } from "./datosPedido.vue?vue&type=template&id=af2334f2&scoped=true&"
import script from "./datosPedido.vue?vue&type=script&lang=js&"
export * from "./datosPedido.vue?vue&type=script&lang=js&"
import style0 from "./datosPedido.vue?vue&type=style&index=0&id=af2334f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2334f2",
  null
  
)

export default component.exports